"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CodeViewerComponent_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeViewerComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const voucher_code_generator_1 = __importDefault(require("voucher-code-generator"));
//@ts-ignore                
let rwsTemplate = T.html `<slot style="display: none;"></slot>

<div class="coding-controls">
   ${(0, fast_element_1.when)(x => !x.codeGenerating, (0, fast_element_1.html) `
        <button class="btn btn-outline-primary" @click="${x => x.toggleCode()}">
            <i class="simple-icon-${x => x.isCodeVisible ? 'close' : 'docs'}"></i> 
            ${x => x.isCodeVisible ? 'code-viewer.hide_code'.t() : 'code-viewer.show_code'.t()}
        </button>
    `)}
    ${(0, fast_element_1.when)(x => x.codeGenerating, (0, fast_element_1.html) `
        <button class="btn btn-outline-primary">
            <i class="simple-icon-clock"></i> ${'code-viewer.writing_code'.t()}...
        </button>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  margin: 10px 0;
  display: block;
}

.coding-controls {
  text-align: center;
}
.coding-controls button {
  padding: 15px;
  font-size: 1.2rem;
  margin: 0 auto;
}`;
const shadowOptions = { "mode": "closed" };
let CodeViewerComponent = CodeViewerComponent_1 = class CodeViewerComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.showLineNumbers = false;
        this.copyButton = true;
        this.componentId = '';
        this.streaming = 'false';
        this.renderedContent = '';
        this.slottedContent = [];
        this.isCodeVisible = true;
        this.codeGenerating = false;
        this.fullTextRendered = false;
        this.firstChunk = true;
        this.hasEnded = false;
        this.updateThrottleId = null;
        this.pendingChunk = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        // Generate a unique ID if none provided
        if (!this.componentId) {
            this.componentId = voucher_code_generator_1.default.generate({ count: 1, length: 8 })[0].toLowerCase();
        }
        // Register this viewer
        this.registerViewer();
        // Listen for chat message sending events to close all viewers
        document.addEventListener('chat:message:sending', CodeViewerComponent_1.handleMessageSending);
        // Listen for code-screen closed events to update state
        document.addEventListener('code-screen:closed', this.handleCodeScreenClosed.bind(this));
        // Restore preserved content if component was recreated
        if (CodeViewerComponent_1._preservedContent[this.componentId] && !this.renderedContent) {
            this.renderedContent = CodeViewerComponent_1._preservedContent[this.componentId];
        }
        // Set up slot observation for content from history
        this.observeSlotChanges();
    }
    disconnectedCallback() {
        // Preserve content when component is destroyed
        if (this.renderedContent) {
            CodeViewerComponent_1._preservedContent[this.componentId] = this.renderedContent;
        }
        // Clean up throttle timer
        if (this.updateThrottleId) {
            cancelAnimationFrame(this.updateThrottleId);
            this.updateThrottleId = null;
        }
        // Unregister this viewer
        this.unregisterViewer();
        // Remove event listener
        document.removeEventListener('chat:message:sending', CodeViewerComponent_1.handleMessageSending);
        // Remove code-screen closed event listener
        document.removeEventListener('code-screen:closed', this.handleCodeScreenClosed.bind(this));
        super.disconnectedCallback();
    }
    renderedContentChanged() {
    }
    getRawContent() {
        return this.renderedContent;
    }
    startCodeGeneration() {
        this.codeGenerating = true;
        // Check if we already have content from early chunks
        const hasEarlyContent = this.renderedContent && this.renderedContent.length > 0;
        // Only initialize if we don't have any content yet
        if (!hasEarlyContent) {
            this.renderedContent = '';
        }
        // Set firstChunk to false if we already have content (came in early)
        this.firstChunk = !hasEarlyContent;
        this.hasEnded = false;
        // Don't clear preserved content if we already have early content
        if (CodeViewerComponent_1._preservedContent[this.componentId] && !hasEarlyContent) {
            delete CodeViewerComponent_1._preservedContent[this.componentId];
        }
        // If we have early content and this isn't the first chunk anymore, show the code
        if (hasEarlyContent && !this.firstChunk) {
            this.showCode();
        }
    }
    stopCodeGeneration() {
        this.codeGenerating = false;
        // Clean up throttle timer and flush any pending chunks
        if (this.updateThrottleId) {
            cancelAnimationFrame(this.updateThrottleId);
            this.updateThrottleId = null;
        }
        // Flush any pending chunk immediately
        if (this.pendingChunk) {
            this.updateCode(this.pendingChunk);
            this.pendingChunk = '';
        }
        this.endStream();
    }
    showCode() {
        // Store content before dispatching event
        CodeViewerComponent_1._preservedContent[this.componentId] = this.renderedContent;
        this.closeOthers();
        this.fireShow();
        this.isCodeVisible = true;
    }
    hideCode() {
        this.dispatchEvent(new CustomEvent('code:close', {
            detail: { componentId: this.componentId },
            bubbles: true,
            composed: true
        }));
        this.isCodeVisible = false;
    }
    updateCode(chunk) {
        this.dispatchEvent(new CustomEvent('code:update', {
            detail: { componentId: this.componentId, chunk },
            bubbles: true,
            composed: true
        }));
    }
    toggleCode() {
        if (this.isCodeVisible) {
            this.hideCode();
        }
        else {
            this.showCode();
        }
    }
    setCodeHidden() {
        this.isCodeVisible = false;
    }
    setCodeVisible() {
        this.isCodeVisible = true;
    }
    endStream() {
        this.hasEnded = true;
        this.dispatchEvent(new CustomEvent('code:stream:ended', {
            detail: { componentId: this.componentId },
            bubbles: true,
            composed: true
        }));
        if (this.language === 'html') {
            this.dispatchEvent(new CustomEvent('code:preview', {
                detail: { codeId: this.componentId },
                bubbles: true,
                composed: true
            }));
        }
    }
    observeSlotChanges() {
        var _a;
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
        if (slot) {
            slot.addEventListener('slotchange', () => {
                this.extractSlottedContent();
            });
            // Initial extraction in case content is already there
            this.extractSlottedContent();
        }
    }
    extractSlottedContent() {
        var _a;
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
        if (slot) {
            const assignedNodes = slot.assignedNodes();
            // Extract content from slotted nodes, treating HTML tags as text content
            let codeContent = '';
            assignedNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    codeContent += node.textContent || '';
                }
                else if (node.nodeType === Node.ELEMENT_NODE) {
                    // For element nodes, we want the HTML tags as text, not rendered HTML
                    // Use outerHTML to get the complete HTML including tags
                    codeContent += node.outerHTML || '';
                }
            });
            // If we have content and we're not in streaming mode, set it and show code
            if (codeContent.trim() && this.streaming === 'false' && !this.renderedContent) {
                // The content should include all HTML tags as text - this is code to be displayed
                this.renderedContent = codeContent.trim();
                this.hasEnded = true; // Mark as ended since it's from history
                // Store content for preservation
                CodeViewerComponent_1._preservedContent[this.componentId] = this.renderedContent;
                // Immediately show the code screen
                this.showCode();
            }
        }
    }
    cleanSlottedHtmlContent(htmlContent) {
        // This method is no longer needed since we want to preserve HTML tags as text
        return htmlContent;
    }
    updateRenderer(text) {
        if (text) {
            this.renderedContent = this.renderedContent + text;
            // Always preserve content as we build it
            CodeViewerComponent_1._preservedContent[this.componentId] = this.renderedContent;
            if (this.firstChunk) {
                this.updateCode(text);
                this.showCode();
                this.firstChunk = false;
            }
            else {
                // Throttle updateCode calls to prevent UI blocking during rapid injection
                this.pendingChunk += text;
                if (this.updateThrottleId) {
                    cancelAnimationFrame(this.updateThrottleId);
                }
                this.updateThrottleId = requestAnimationFrame(() => {
                    if (this.pendingChunk) {
                        this.updateCode(this.pendingChunk);
                        this.pendingChunk = '';
                    }
                    this.updateThrottleId = null;
                });
            }
        }
    }
    handleCodeScreenClosed(event) {
        const customEvent = event;
        const closedComponentId = customEvent.detail.componentId;
        // If this is the code-viewer associated with the closed code-screen, update state
        if (closedComponentId === this.componentId) {
            this.setCodeHidden();
        }
    }
    registerViewer() {
        CodeViewerComponent_1._activeViewers.push(this);
    }
    unregisterViewer() {
        const index = CodeViewerComponent_1._activeViewers.indexOf(this);
        if (index > -1) {
            CodeViewerComponent_1._activeViewers.splice(index, 1);
        }
    }
    /**
     * Static method to close all active code viewers
     */
    static closeAllViewers() {
        CodeViewerComponent_1._activeViewers.forEach(viewer => {
            if (viewer.isCodeVisible) {
                viewer.hideCode();
            }
        });
    }
    closeOthers() {
        // First, dispatch event to close other code-viewers
        const closeOthersEvent = new CustomEvent('code-viewer:close-others', {
            detail: { excludeId: this.componentId },
            bubbles: true,
            composed: true
        });
        if (this.fullTextRendered) {
            if (CodeViewerComponent_1._closeAllTimeout) {
                clearTimeout(CodeViewerComponent_1._closeAllTimeout);
            }
            CodeViewerComponent_1._closeAllTimeout = setTimeout(() => {
                this.dispatchEvent(closeOthersEvent);
                setTimeout(() => {
                    this.fireShow();
                }, 100);
            }, 300);
        }
        else {
            this.dispatchEvent(closeOthersEvent);
        }
    }
    fireShow() {
        var _a;
        // For HTML content, include preview flag
        const isHtml = ((_a = this.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'html';
        const ev = new CustomEvent('code:show', {
            detail: {
                code: this.renderedContent,
                id: this.componentId,
                language: this.language,
                preview: isHtml && this.hasEnded,
                ended: this.hasEnded
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(ev);
    }
};
exports.CodeViewerComponent = CodeViewerComponent;
CodeViewerComponent._preservedContent = {};
CodeViewerComponent._closeAllTimeout = null;
CodeViewerComponent._activeViewers = [];
/**
 * Static event handler for message sending events
 */
CodeViewerComponent.handleMessageSending = () => {
    CodeViewerComponent_1.closeAllViewers();
};
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeViewerComponent.prototype, "showLineNumbers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeViewerComponent.prototype, "copyButton", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CodeViewerComponent.prototype, "language", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CodeViewerComponent.prototype, "componentId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CodeViewerComponent.prototype, "streaming", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CodeViewerComponent.prototype, "renderedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CodeViewerComponent.prototype, "slottedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeViewerComponent.prototype, "isCodeVisible", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeViewerComponent.prototype, "codeGenerating", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CodeViewerComponent.prototype, "fullTextRendered", void 0);
exports.CodeViewerComponent = CodeViewerComponent = CodeViewerComponent_1 = __decorate([
    (0, client_1.RWSView)('code-viewer', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], CodeViewerComponent);
CodeViewerComponent.defineComponent();
